<template>
<div class="botaccount" :style="navbarWithName ? 'margin-left: 150px !important; margin-right: auto !important;' : ''"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
  <v-snackbar v-model="alertSuccess" :timeout="4000" top right color='primary' >
      <v-icon x-medium class="white--text">mdi-checkbox-marked-circle</v-icon>    <span>{{ alert_err_attention }}</span>
  </v-snackbar>
  <v-snackbar v-model="alertFailed" :timeout="4000" top right color='red' >
    <v-icon x-medium class="white--text">mdi-minus-circle</v-icon>   <span>{{ alert_err_attention }}</span>
  </v-snackbar>
  <v-breadcrumbs :items="page" class="ml-2 mt-0 pt-0"></v-breadcrumbs>
    <template >
      <v-toolbar flat>
        <v-toolbar-title style="margin-left: 20px;"><v-icon class="mr-2">mdi-twitter</v-icon>{{ this.$store.state.title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-flex lg3>
          <v-text-field class="pt-3 mr-4" v-model="search" append-icon="mdi-magnify" label="Search"></v-text-field>
        </v-flex>
        <!--v-dialog-->
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn 
              v-show=insertact
              outlined
              rounded
              small
              color="primary"
              dark
              class="mb-2"
              v-bind="attrs"
              v-on="on"
              >
              Add New Bot Account
              <v-icon class="ml-2">mdi-plus</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title><span class="text-h6">{{ formTitle }}</span></v-card-title>
            <v-card-text style="height: 500px;" class="overflow-card">
                <v-form class="ml-2" ref="form" lazy-validation>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field outlined dense v-model="iteminput.username" :rules="usernamerules" label="Username" 
                        hint="Input Username" persistent-hint>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field outlined dense v-model="iteminput.password"  label="Password" 
                        hint="Input Password" persistent-hint>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <div v-if="!fileCookie">
                          <div
                            :class="[
                              'drop-zone-file-cookie',
                              draggingFileCookie ? 'drop-zone-file-cookie-over' : '',
                            ]"
                            @dragenter="draggingFileCookie = true"
                            @dragleave="draggingFileCookie = false"
                          >
                            <div
                              class="drop-zone-file-cookie-info"
                              ref="file"
                              @drag="selectFileCookie"
                            >
                              <span class="fa fa-cloud-upload drop-zone-file-cookie-title"></span>
                              <span class="drop-zone-file-cookie-title">
                                Drop file cookie or click to input<br />
                              </span>
                              <div class="drop-zone-file-cookie-upload-limit-info"></div>
                            </div>

                            <input
                              type="file"
                              ref="file"
                              id="files"
                              name="files"
                              @change="selectFileCookie"
                            />
                          </div>
                        </div>

                        <div v-else class="drop-zone-file-cookie-uploaded">
                          <div class="drop-zone-file-cookie-uploaded-info">
                            <button
                              class="btn remove-file-cookie"
                              style="background-color: #439EDF; color: #fff; border: none;"
                              type="button"
                              @click="removeFileCookie"
                            >
                              Remove File Cookie
                            </button>

                            <span class="drop-zone-file-cookie-title"></span><br />

                            <v-col>
                              {{ nameFileCookie }}
                            </v-col>
                          </div>
                        </div>
                      </v-col>

                      <p v-if="fileCookieError" class="ml-3 red--text">
                        File cookie is required
                      </p>

                      <v-col cols="12" sm="12" md="12">
                        <v-btn
                          class="mb-2"
                          color="success"
                          medium
                          :loading="loadingTestFileCookie"
                          @click="testFileCookie"
                        >
                          Test
                        </v-btn>

                        <div class="ml-1">
                          <span class="font-weight-medium">
                            Status:
                          </span>
                          <span
                            :class="statusCookie == 'Success' ? 'green--text' : 'red--text'"
                            class="ml-1"
                          >
                            {{ statusCookie }}
                          </span>
                        </div>
                      </v-col>
                      <!-- <v-col cols="12" sm="12" md="12">
                        <v-text-field outlined dense v-model="iteminput.kdt" :rules="kdtrules" label="KDT" 
                        hint="Input KDT" persistent-hint>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field outlined dense v-model="iteminput.ct0" :rules="ct0rules" label="CT0" 
                        hint="Input CT0" persistent-hint>
                        </v-text-field>
                      </v-col> -->
                    </v-row>
                  </v-container>
                </v-form>
            </v-card-text>

              <v-divider></v-divider>
              <v-card-actions class="py-3">
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="close">
                  Cancel
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  style="width: 90px;"
                  rounded
                  dense
                  :dark="statusCookie == 'Success'"
                  :loading="btnload"
                  :disabled="statusCookie != 'Success'"
                  @click="save"
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="dialogWrongExtension"
            persistent
            max-width="330px"
          >
            <v-card
              class="text-center align-center justify-center pa-6 rounded-lg"
              style="border-radius: 30px"
              width="330px"
            >
              <v-avatar class="dialog-wrong-extension mb-4 mt-2" size="62">
                <v-icon x-large class="white--text">
                  mdi-close
                </v-icon>
              </v-avatar>

              <div class="text-center text-h6 align-center justify-center" style="word-break: break-word">
                File cookie you uploaded has the wrong extension.
              </div>

              <v-divider class="mt-4"></v-divider>

              <v-card-actions class="align-center justify-center">
                <v-btn
                  class="my-3 dialog-wrong-extension"
                  width="180px"
                  rounded
                  dark
                  @click="dialogWrongExtension = false, removeFileCookie()"
                >
                  OK
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogDelete" width="330px">
            <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
              <v-avatar class="color-avatar3 my-4" size="62">
                <v-icon x-large class="white--text">mdi-alert-octagon</v-icon>
              </v-avatar>
              <div class="text-center text-h6 align-center justify-center font-weight-medium">
                Confirm Deletion
              </div>
              <v-card-text class="align-center justify-center mt-2">
                Are you sure you want to permanently delete this item?
              </v-card-text>

              <v-divider class="mt-4" style=""></v-divider>

              <v-card-actions class="align-center justify-center">
                <v-btn rounded class="my-3 btn-ok" width="90px" dark @click="deleteItemConfirm">
                  OK
                </v-btn>
                <v-btn rounded outlined class="my-3" width="90px" color="red" dark @click="closeDelete">
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>




          
              <!-- dialog informasi topic  -->
              <v-dialog v-model="dialoginformasibot" max-width="700px">
                <v-card>
                  <v-card-title>
                    <span class="text-h6">Bot Account</span>
                  </v-card-title>
                  <v-card-text>
                    <v-list-item>
                      <v-list-item-avatar color="#EDF4FB">
                        <v-icon color="#439EDF" dark>
                          mdi-alert-outline
                        </v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content> 
                        <v-list-item-title>{{textDialogvalid}}</v-list-item-title>
                        <v-list-item-subtitle></v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider inset></v-divider>
                    <v-list-item>
                      <v-list-item-avatar color="#EDF4FB">
                        <v-icon color="#439EDF" dark>
                          mdi-clock-outline
                        </v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>Last Check</v-list-item-title>
                        <v-list-item-subtitle>{{lastDateDialogvalid}}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider inset></v-divider>
                    <v-list-item>
                      <v-list-item-avatar color="#EDF4FB">
                        <v-icon color="#439EDF" dark>
                          mdi-message-text-outline
                        </v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>Message</v-list-item-title>
                        <v-list-item-subtitle>{{messageInvalidBot}}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider inset></v-divider>
                  </v-card-text>
                  <v-card-actions class="py-3">
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="closeInformasiTopicDialog">
                      Cancel
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>



      </v-toolbar> 
    </template>
        <v-data-table
          :headers="headers"
          :items="botaccount"
          :single-expand="true"
          :expanded.sync="expanded"
          item-key="SEQ_ID"
          class="table-user ml-6 mr-6 mt-4 rounded-lg"
          :loading="tableLoading"
          loading-text="Loading data..."
           show-expand 
        >
  <!-- show-expand -->

          <!-- Correct slot usage for item.STATUS --> 
          <template v-slot:item.valid="{ item }">
            <v-icon
              class="mr-2"
              small
              @click="informasiItembot(item.SEQ_ID,item.valid,item.last_checked,item.SYS_UPDATED_DATE,item.MESSAGE)"
              :style="{
                color: item.valid === 1 ? 'blue' : 'red',
                borderRadius: '50%',
                visibility: item.valid === 1 ? 'hidden' : 'visible', // Ensures icon still takes space but is hidden
              }"
            >
              {{ item.valid === 1 ? 'mdi-star' : 'mdi-alert-outline' }}
            </v-icon>
            
            {{ item.NAME }}   
          </template>

          <!-- Buttons for BOT_FOLLOW and BOT_SEARCH with checkmark and cross -->
          <template v-slot:item.BOT_FOLLOW="{ item }">
              <v-icon 
                class="mr-2" 
                small 
                :style="{
                  backgroundColor: item.BOT_FOLLOW === 1 ? 'rgb(4, 113, 165)' : 'red',
                  color: 'white', 
                  borderRadius: '50%',
                }"
                @click="updatebot(item.SEQ_ID,item.BOT_FOLLOW,'BOT_FOLLOW')"
              >
                {{ item.BOT_FOLLOW === 1 ? 'mdi-check' : 'mdi-close' }}
              </v-icon> 
          </template>

          <template v-slot:item.BOT_SEARCH="{ item }">
              <v-icon 
                class="mr-2" 
                small 
                :style="{
                  backgroundColor: item.BOT_SEARCH === 1 ? 'rgb(4, 113, 165)' : 'red',
                  color: 'white', 
                  borderRadius: '50%',
                }"
                @click="updatebot(item.SEQ_ID,item.BOT_SEARCH,'BOT_SEARCH')"
              >
                {{ item.BOT_SEARCH === 1 ? 'mdi-check' : 'mdi-close' }}
              </v-icon>
          </template>

          <template v-slot:item.BOT_REVISIT="{ item }">
            
            <v-icon 
                class="mr-2" 
                small 
                :style="{
                  backgroundColor: item.BOT_REVISIT === 1 ? 'rgb(4, 113, 165)' : 'red',
                  color: 'white', 
                  borderRadius: '50%',
                }"
                @click="updatebot(item.SEQ_ID,item.BOT_REVISIT,'BOT_REVISIT')"
              >
                {{ item.BOT_REVISIT === 1 ? 'mdi-check' : 'mdi-close' }}
              </v-icon>
          </template>
          

          <!-- Correct slot usage for item.STATUS -->
          <template v-slot:item.BOT_STATUS_TEXT="{ item }">
            <v-chip :color="getColor(item.BOT_STATUS_TEXT)"  @click="updatebotstatus(item.SEQ_ID,item.BOT_STATUS_TEXT)" text-color="white" label small pill>
              {{ item.BOT_STATUS_TEXT }} 
            </v-chip>
          </template>


          <template v-slot:[`item.actions`]="{ item }">
            <v-icon class="mr-2" small v-show="updateact" @click="editItem(item.SEQ_ID)">
              mdi-pencil
            </v-icon>
            <v-icon small v-show="deleteact" @click="deleteItem(item.SEQ_ID)">
              mdi-delete
            </v-icon>
          </template>

          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Reset</v-btn>
          </template>
          <template  v-slot:expanded-item="{ headers, item }">

            <v-expand-transition>
              <td :colspan="headers.length" class="pa-3">
                <p>PASSWORD: {{ item.PASSWORD }}</p>
                <p>Created By: {{ item.USERCREATE }}</p>
                <p>Created Date: {{ item.SYS_CREATED_DATE }}</p>
                <p>Update By: {{ item.USERUPDATE }}</p>
                <p>Update Date: {{ item.SYS_UPDATED_DATE }}</p>
              </td>
            </v-expand-transition>
            <!-- <td :colspan="headers.length" elevation="0" class="pa-3 elevation-0">
              <p> PASSWORD: {{ item.PASSWORD }} </p>
              <p> Created By: {{ item.USERCREATE }} </p>
              <p> Created Date: {{ item.SYS_CREATED_DATE }} </p>
              <p> Update By: {{ item.USERUPDATE }} </p>
              <p> Update Date: {{ item.SYS_UPDATED_DATE }} </p>
            </td> -->
          </template>
        </v-data-table>
        <Notification  ref="alert"></Notification>
    </div>
</template>


<script>

import axios from "axios";
import { decryptionData } from '@/components/utils/utils.js';
import Notification from  '@/components/Notification';
import { mapGetters } from 'vuex';
  export default {
    components: {
      Notification: Notification
    },
    data: () => ({
      draggingFileCookie: false,
      fileCookie: "",
      nameFileCookie: "",
      fileCookieError: false,
      loadingTestFileCookie: false,
      statusCookie: "",
      dialogWrongExtension: false,

      btnload:false,
      alertSuccess:'',
      alertFailed:'',
      alert_err_attention: "",
    
      deleteact: false,
      insertact: false,
      updateact: false,
      viewact: false,
      // namerules: [
      //   v => !!v || 'Bot Twitter is required',
      //   v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'Bot Twitter can only contain letters, numbers, spaces and special characters (.@_-)',
      // ],
      usernamerules: [
        v => !!v || 'username is required',
        // v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'username can only contain letters, numbers, spaces and special characters (.@_-)',
      ],
      // kdtrules: [
      //   v => !!v || 'KDT is required',
      //   v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'KDT can only contain letters, numbers, spaces and special characters (.@_-)',
      // ],
      // ct0rules: [
      //   v => !!v || 'ct0 is required',
      //   v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'ct0 can only contain letters, numbers, spaces and special characters (.@_-)',
      // ],
      
        
      dialog: false, 
      dialogDelete: false,
      dialoginformasibot: false,

      textDialogvalid:'',
      lastDateDialogvalid:'',
      messageInvalidBot: '',
      
      
      expanded: [],
      singleExpand: true,
      search:'',
      headers: [
         { text: '', value: 'data-table-expand', width: 60 },
         { text: '', value: 'valid', width: 20 },
        { text: 'USERNAME', value: 'USERNAME' },
        // { text: 'username', value: 'username' },
        { text: 'FOLLOW', value: 'BOT_FOLLOW' },
        { text: 'SEARCH', value: 'BOT_SEARCH' },
        { text: 'REVISIT', value: 'BOT_REVISIT' },
        { text: 'STATUS', value: 'BOT_STATUS_TEXT' },
        { text: 'Actions', value: 'actions' },
      ],
      
      botaccount: [],
      id_bot_account:"",
      status:"",
      iteminput: {
      },
      defaultItem: {
      },
      editedIndex: -1,
    }),
    computed: {
      page() {
        return this.$store.state.breadcrumbs
      },
      ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
      formTitle () {
        return this.editedIndex === -1 ? 'Add Bot Account' : 'Update Bot Account'
      },
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
      informasiItembot (val,valid,last_date,last_update,message) {
        console.log(last_date)
        
        valid || this.closeInformasiTopicDialog()
        val || this.closeInformasiTopicDialog()
        last_update || this.closeInformasiTopicDialog()
        message || this.closeInformasiTopicDialog()
      },

      dialoginformasitopic(val){
        val || this.closeInformasiTopicDialog()
      },
    },
    created () {
      this.initialize()
    },
    methods: {
      selectFileCookie(event) {
        const file =
          event?.target?.files?.[0] ||
          event?.dataTransfer?.files?.[0];

        if (!file) return;

        const allowedExtensions = ["json", "txt"];
        const fileExtension = file.name.split(".").pop().toLowerCase();

        if (!allowedExtensions.includes(fileExtension)) {
          this.dialogWrongExtension = true;
          this.draggingFileCookie = false;

          if (event?.target) {
            event.target.value = "";
          }

          return;
        }

        this.fileCookie = file;
        this.nameFileCookie = file.name;
        this.fileCookieError = false;
        this.draggingFileCookie = false;
      },
      removeFileCookie() {
        this.fileCookie = "";
        this.nameFileCookie = "";
        this.fileCookieError = false;
        this.statusCookie = null;

        if (this.$refs.file) {
          this.$refs.file.value = null;
        }
      },
      async testFileCookie() {
        this.statusCookie = "";
        this.loadingTestFileCookie = true;

        if (!this.fileCookie) {
          this.fileCookieError = true;
          this.statusCookie = "Failed";

          setTimeout(() => {
            this.fileCookieError = false;
          }, 5000);

          this.loadingTestFileCookie = false;
          return;
        }

        try {
          const axiosInstance = axios.create({
            baseURL: "/apitestcookie",
          });

          const formData = new FormData();
          formData.append("username", this.iteminput.username);
          formData.append("file", this.fileCookie);

          await axiosInstance.post("/decode", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });

          const validCekPayload = {
            username: this.iteminput.username,
          };

          const validCekResponse = await axiosInstance.post(
            "/valid-cek",
            validCekPayload,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          const result = validCekResponse.data;

          if (result?.data && Array.isArray(result.data) && result.data.length > 0) {
            const userData = result.data[0];
            this.statusCookie = userData?.valid == 1 ? "Success" : "Failed";
          } else if (result?.valid !== undefined) {
            this.statusCookie = result?.valid == 1 ? "Success" : "Failed";
          } else {
            this.statusCookie = "Failed";
          }
        } catch (error) {
          this.statusCookie = "Failed";
        } finally {
          this.loadingTestFileCookie = false;
        }
      },
      informasiItembot(seq_id,valid,last_date,last_update,message){
        console.log(seq_id)
        console.log(valid)
        this.dialoginformasibot = true
        var date  = last_date === "" ? last_update : last_date;
        
        this.textDialogvalid='Bot Invalid'
        this.lastDateDialogvalid= date
        this.messageInvalidBot = message
      },
      
      closeInformasiTopicDialog(){
        this.dialoginformasibot = false
      },
      expandRow(botacctid) {
        // Toggle the expanded row: if the current row is expanded, collapse it, otherwise expand it
        this.expanded = this.expanded === botacctid ? null : botacctid;
      },
      getColor(status) {
        return status === 'Disabled' ? 'red' : 'green';
      },
      initialize () {
        
        this.tableLoading = true;
        axios.get("bot_twitter",
          { headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            const data = decryptionData(response.data.token);
            this.botaccount = data;
            // end loading 
            setTimeout(() =>{
              this.loading = false
            },1000)
            this.tableLoading = false;
            if(localStorage.getItem('authactdeletedt') == 1){ this.deleteact = true }
            if(localStorage.getItem('authactinsert') == 1){ this.insertact = true }
            if(localStorage.getItem('authactupdate') == 1){ this.updateact = true }
            if(localStorage.getItem('authactview') == 1){ this.viewact = true }
          })
          .catch((e) => {
              switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                  }
          this.errors=e.data.msg;
        });
      },
      updatebot (seq_id,status,name_status) {
        axios({
          method: "put",
          url: "bot_twitter/update_status_crawler",
          data: {
            seq_id: seq_id,
            status: status,
            name_status: name_status
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
          var status = response.data.status
          var messages = response.data.msg
          if(status == 200){
            this.initialize ();
            this.alertSuccess = true;
            this.alert_err_attention =  messages;
            this.closeDelete()
          }else{
              this.alertFailed = true;
              this.alert_err_attention =  messages;
          } 
        })
        .catch(function (error) {
          // handle error
          this.alertFailed = true;
          this.alert_err_attention =  'Delete Failed '+error;
        })

      },
      updatebotstatus (seq_id,status) {
        axios({
          method: "put",
          url: "bot_twitter/update_status_action",
          data: {
            seq_id: seq_id,
            status: status
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
          var status = response.data.status
          var messages = response.data.msg
          if(status == 200){
            this.initialize ();
            this.alertSuccess = true;
            this.alert_err_attention =  messages;
            this.closeDelete()
          }else{
              this.alertFailed = true;
              this.alert_err_attention =  messages;
          } 
        })
        .catch(function (error) {
          // handle error
          this.alertFailed = true;
          this.alert_err_attention =  'Delete Failed '+error;
        })

      },
      deleteItem (item) {
        
        this.id_bot_account = item
        this.editedIndex = this.botaccount.indexOf(item)
        this.iteminput = Object.assign({}, item)
        this.dialogDelete = true
      },
      deleteItemConfirm () {
        this.botaccount.splice(this.editedIndex, 1)
        
        axios({
          method: "delete",
          url: "bot_twitter/delete",
          data: {
            id: this.id_bot_account
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
          // handle success
          
          var status = response.data.status
          var messages = response.data.msg
          if(status == 200){
            this.initialize ();
            this.alertSuccess = true;
            this.alert_err_attention =  messages;
            this.closeDelete()
          }else{
              this.alertFailed = true;
              this.alert_err_attention =  messages;
          } 
        })
        .catch(function (error) {
          // handle error
          this.alertFailed = true;
          this.alert_err_attention =  'Delete Failed '+error;
        })
        this.closeDelete()
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.iteminput = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      editItem (item) {
        this.statusCookie = "";
        this.removeFileCookie();

        this.editedIndex = 1
        // this.editedIndex = this.botaccount.indexOf(item)
        this.iteminput = Object.assign({}, item)
        this.dialog = true
        axios({
          method: "put",
          url: "/bot_twitter_Id",
          data: {
            id: item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
          
          const dat = decryptionData(response.data.token);
            // const dat = response.data;
            this.id_bot_account = dat.SEQ_ID;
            
            this.iteminput = {
              name:dat.NAME,
              username:dat.USERNAME,
              password:dat.PASSWORD,
              // kdt:dat.KDT,
              // ct0:dat.CT0,
            }
            
              // this.mediabotactive=  dat.BOT_MEDIA
              // this.statusactive=  dat.BOT_STATUS
        
            setTimeout(() =>{
              this.loading = false
            },1000)
          
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
      },
      save () {
        
        const isValid = this.$refs.form.validate();
        if (isValid) {
          this.btnload = true
          if (this.editedIndex > -1) {
            Object.assign(this.botaccount[this.editedIndex], this.iteminput)
            axios.put("/bot_twitter/update", 
              {
                seq_id:this.id_bot_account,
                // name:this.iteminput.name,
                username:this.iteminput.username,
                password:this.iteminput.password,
                // kdt:this.iteminput.kdt,
                // ct0:this.iteminput.ct0,
                // bot_status:this.statusactive,
                // bot_media:this.mediabotactive,
              },
              
              {headers:{'auth-token':localStorage.getItem('token_app')}},
              {dataType: 'json'}
              )
            .then((response) => {
                var status = response.data.status
                var messages = response.data.msg
                if(status == 200){
                  this.initialize();
                  this.$router.push('/bottwitter');
                  this.alertSuccess = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
                  this.close()
                }else{
                    this.alertFailed = true;
                    this.alert_err_attention =  messages;
                    this.btnload = false
                    this.close()
                } 
              })
            .catch((e) => {
                  switch (e.response.status) {
                      case 404:
                            this.$refs.alert.error_login(404);
                          break;
                      case 403:
                            this.$refs.alert.error_login(403);
                          break;
                      default:
                          console.log('some other error');  // end up here all the time
                          break;
                      }
              this.errors=e.response.data.msg;
            });
          } 
          else {
            this.botaccount.push(this.iteminput)
            axios.post("/bot_twitter/insert", 
              {
                // name:this.iteminput.name,
                username:this.iteminput.username,
                password:this.iteminput.password,
                // kdt:this.iteminput.kdt,
                // ct0:this.iteminput.ct0,
                // bot_status:this.statusactive,
                // bot_media:this.mediabotactive,
                
              },
              { headers:{'auth-token':localStorage.getItem('token_app')}},
              {dataType: 'json'}
              )
            .then((response) => {
                var status = response.data.status
                var messages = response.data.msg
                if(status == 200){
                  this.initialize();
                  this.$router.push('/bottwitter');
                  this.alertSuccess = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
                  this.close()
                }else{
                    this.alertFailed = true;
                    this.alert_err_attention =  messages;
                    this.btnload = false
                } 
              })
            .catch((e) => {
                  switch (e.response.status) {
                      case 404:
                            this.$refs.alert.error_login(404);
                          break;
                      case 403:
                            this.$refs.alert.error_login(403);
                          break;
                      default:
                          console.log(e.response.msg);  // end up here all the time
                          break;
                      }
              this.errors=e.response.data.msg;
            });
          } 
        }
      },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.iteminput = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
    },
  }
</script>

<style scoped>
.drop-zone-file-cookie {
  position: relative;
  border: 2px dashed #eee;
  height: 200px;
  width: 100%;
}
.drop-zone-file-cookie:hover {
  border: 2px solid #439EDF;
}
.drop-zone-file-cookie:hover .drop-zone-file-cookie-title {
  color: #439EDF;
}
.drop-zone-file-cookie-over {
  background: #5c5c5c;
  opacity: 0.8;
}
.drop-zone-file-cookie input {
  position: absolute;
  cursor: pointer;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
}
.drop-zone-file-cookie-info {
  color: #a8a8a8;
  position: absolute;
  text-align: center;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
}
.drop-zone-file-cookie-title {
  color: #787878;
}
.drop-zone-file-cookie-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}
.drop-zone-file-cookie-uploaded {
  position: relative;
  border: 2px dashed #eee;
  height: 200px;
  width: 100%;
}
.drop-zone-file-cookie-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #a8a8a8;
  position: absolute;
  text-align: center;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
}
.remove-file-cookie {
  width: 200px;
}
.dialog-wrong-extension {
  background-image: linear-gradient(
    to bottom,
    #ff8b8b,
    #ff8284,
    #ff787d,
    #ff6e76,
    #ff646f,
    #ff5c6a,
    #ff5464,
    #ff4b5f,
    #ff4359,
    #ff3b54,
    #ff314e,
    #ff2648
  );
}
.btn-ok{
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
.v-avatar.color-avatar3
{
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
</style>